import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  errorFlag: false,
  errorDetails: {},
};

export const errorSlice = createSlice({
  name: 'errorBoundarySlice',
  initialState,
  reducers: {
    setErrorFlag: (state, action) => {
      if (state.errorFlag === action.payload) return;
      state.errorFlag = action.payload;
    },
    setErrorDetails: (state, action) => {
      state.errorDetails = action.payload;
    },
  },
});

export const { setErrorFlag, setErrorDetails } = errorSlice.actions;

export default errorSlice.reducer;
